export default __webpack_public_path__ + "static/media/08.cc24f82d.jpg";